import React, { useState } from 'react';
import Header from '../components/Header';
import Banner from '../components/Banner';
import About from '../components/About';
import Upload from '../components/Upload';
import Footer from '../components/Footer';
import Plans from '../components/Plans';

function Home() {
  const [planBuyed, setPlanBuyed] = useState(false);
  return (
    <>
      <Header />
      <Banner />
      <About />
      <Plans setPlanBuyed={setPlanBuyed} />
      <Upload planBuyed={planBuyed} />
      <Footer />
    </>
  );
}

export default Home;
